import { DEFAULT_SORT } from './models/filter';

export const BASE_CATALOG_PARAMS_PATH = '/catalog';

export const DEFAULT_CATALOG_PATH = '/catalog';
export const ENROLLMENTS_CATALOG_PATH = '/catalog?scope=enrolled';
export const COMPLETED_CATALOG_PATH = '/catalog?scope=completed';
export const SEARCH_RESULTS_PATH = '/catalog?sort=relevance';

export const DEFAULT_PAGE_PARAMS: Record<string, string> = {
  scope: 'all',
  price: 'any-price',
  school: 'any-school',
  skill: 'any-skill',
  difficulty: 'any-difficulty',
  duration: 'any-duration',
  type: 'any-type',
  sort: DEFAULT_SORT,
  page: 'page-1',
};

export const RAW_DURATION_LABELS = {
  LT20: '< 20 Hours',
  MID: '20 - 60 Hours',
  GT60: '> 60 Hours',
} as const;

export const RAW_DURATION_KEYS = {
  LT20: 'lt1200',
  MID: '1200to3600',
  GT60: 'gt3600',
} as const;

export const RAW_DURATION_VALUES = {
  LT20: '< 1200',
  MID: '1200 TO 3600',
  GT60: '> 3600',
} as const;

export const RAW_DURATION_MAPPING: Record<string, string> = {
  [RAW_DURATION_LABELS.LT20]: RAW_DURATION_KEYS.LT20,
  [RAW_DURATION_LABELS.MID]: RAW_DURATION_KEYS.MID,
  [RAW_DURATION_LABELS.GT60]: RAW_DURATION_KEYS.GT60,
} as const;

export const RAW_DURATION_REVERSE_MAPPING: Record<string, string> = {
  [RAW_DURATION_KEYS.LT20]: RAW_DURATION_LABELS.LT20,
  [RAW_DURATION_KEYS.MID]: RAW_DURATION_LABELS.MID,
  [RAW_DURATION_KEYS.GT60]: RAW_DURATION_LABELS.GT60,
} as const;

export const CATALOG_FILTER_LOCALE_CONFIG = {
  DEFAULT_LOCALE: 'en-us',
  TRANSLATED_LOCALES: ['ja'],
} as const;
